"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.promisifyScript = promisifyScript;
exports.getErrorClassName = getErrorClassName;
exports.isSuperUser = exports.isBrowser = exports.isUserLoggedIn = exports.getToken = void 0;
/* eslint-disable no-undef */

/* eslint-disable import/prefer-default-export */

function promisifyScript(src) {
  return new Promise(function (resolve, reject) {
    var script = window.document.createElement('script');
    script.src = src;
    script.addEventListener('load', function () {
      return resolve();
    });
    script.addEventListener('error', function (e) {
      return reject(e);
    });
    window.document.body.appendChild(script);
  });
}

function getErrorClassName(error) {
  var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'is-invalid';
  var errorClassName = '';
  if (error) errorClassName = className;
  return errorClassName;
}

var getToken = function getToken() {
  return localStorage.getItem('token');
};

exports.getToken = getToken;

var isUserLoggedIn = function isUserLoggedIn() {
  return Boolean(getToken());
};

exports.isUserLoggedIn = isUserLoggedIn;

var isBrowser = function isBrowser() {
  return typeof window !== 'undefined';
};

exports.isBrowser = isBrowser;

var isSuperUser = function isSuperUser() {
  return isBrowser && localStorage.getItem('roles') && localStorage.getItem('roles').includes('superuser');
};

exports.isSuperUser = isSuperUser;